import { render, staticRenderFns } from "./costShift.vue?vue&type=template&id=b5188976"
import script from "./costShift.vue?vue&type=script&lang=js"
export * from "./costShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports